import { API_ROUTES } from '@/constants/apiRoutes';
import { deletePayload } from '@/features/configuration-management/commision-management/slab/table/Column';
import { AxiosInstance } from 'axios';

export interface ManageSlabPayload {
  categoryId: string;
  adminCommissionTypeId: string;
  categoryName: string;
  categoryDetailId: string;
  fromAmount: number;
  toAmount: number;
  commissionValue: number;
  commissionPercentageType: string;
  minCommissionValue: number;
  maxCommissionValue: number;
}

const manageSlab = (client: AxiosInstance) => async (payload: ManageSlabPayload) => {
  return (
    await client.post<{ message: string; data: ManageSlabPayload }>(API_ROUTES.MANAGE_COMMISSION_DETAIL, {
      ...payload,
    })
  ).data;
};
const deleteSlab = (client: AxiosInstance) => async (payload?: deletePayload) => {
  return (await client.post<{ message: string }>(API_ROUTES.DELETE_COMMISSION_DETAIL, payload)).data;
};

export const slabMutations = {
  manageSlab,
  deleteSlab,
};
